import { createStore, combineReducers } from "redux";
import currentPathReducer from './reducers/currentPathReducer'

export default createStore(combineReducers({Auth:currentPathReducer}));
